module.exports = __webpack_public_path__ + "./fonts/Muli-Black.ttf";